// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---qpupH","changedRecordsList":"changedRecordsList---BTiLg","changedRecord":"changedRecord---yXTCo"};